import { render } from "./SVGBar.vue?vue&type=template&id=6a7738de"
import script from "./SVGBar.vue?vue&type=script&lang=js"
export * from "./SVGBar.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__